// CSS Modules - component class name prefix: Accordion__

<template>
  <div :class="$style.container">
    <div
      v-for="(accordionItem, index) in itemCollection"
      :key="getIdentifier(accordionItem)"
      :class="$style.accordionItem"
    >
      <a
        @click.prevent="
          multipleActive
            ? toggleMultipleMode(getIdentifier(accordionItem))
            : toggleSingleMode(getIdentifier(accordionItem))
        "
        :class="[
          $style.title,
          {
            [$style.active]: openItems.includes(getIdentifier(accordionItem))
          }
        ]"
      >
        <slot name="title" :accordionItem="accordionItem" :index="index"></slot>
      </a>

      <transition
        name="accordionToggle"
        appear
        @before-appear="beforeAppear"
        @appear="appear"
        @before-enter="beforeEnter"
        @enter="enter"
        @before-leave="beforeLeave"
        @leave="leave"
      >
        <div
          v-show="openItems.includes(getIdentifier(accordionItem))"
          :class="$style.content"
        >
          <slot
            name="content"
            :accordionItem="accordionItem"
            :index="index"
          ></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    itemCollection: {
      type: Array,
      default: () => []
    },
    initialOpenAccordionItems: {
      type: Array,
      default: () => []
    },
    multipleActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      CONTENT_PADDING: 15,
      openItems: []
    };
  },
  methods: {
    getIdentifier(accordionItem) {
      return `accordion_${JSON.stringify(accordionItem)}`;
    },
    toggleSingleMode(identifier) {
      this.openItems = this.openItems.includes(identifier) ? [] : [identifier];
    },
    toggleMultipleMode(identifier) {
      if (this.openItems.includes(identifier)) {
        this.openItems = this.openItems.filter(item => {
          return item !== identifier;
        });
      } else {
        this.openItems.push(identifier);
      }
    },
    reset() {
      this.openItems = [];
    },
    beforeAppear(el) {
      el.style.height = "0";
    },
    appear(el) {
      const timeOut = setTimeout(() => {
        el.style.height = el.scrollHeight + this.CONTENT_PADDING + "px";
        clearTimeout(timeOut);
      }, 1000);
    },
    beforeEnter(el) {
      el.style.height = "0";
    },
    enter(el) {
      el.style.height = el.scrollHeight + this.CONTENT_PADDING + "px";
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + this.CONTENT_PADDING + "px";
    },
    leave(el) {
      el.style.height = "0";
    }
  },
  created() {
    if (
      this.initialOpenAccordionItems &&
      this.initialOpenAccordionItems.length
    ) {
      this.openItems = [...this.initialOpenAccordionItems];
    }
  }
};
</script>

<style module lang="scss">
@import "./Accordion.scss";
</style>
